import { app } from '../../../app';

app.factory('HardTokenSyncService', HardTokenSyncService);

/** @ngInject */
function HardTokenSyncService($resource) {
    // hardtoken/synchronize POST
    // hardtoken/synchronize/{trackerId} GET
    // hardtoken/synchronize/{trackerId} POST
    return $resource('app/rest/hardtoken/synchronize/:trackerId', {
        trackerId : "@trackerId"
    }, {});

}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-sync/hard-token-sync.service.js